import styled from "@emotion/styled";
import {Box, Container} from "@mui/material";
import {media} from "assets/css/media";
import {TeamRegion} from "data/enums";
import golfers from "assets/img/golfers.png";
import topLine from "assets/img/top_line_desktop.png";
import bottomLine from "assets/img/bottom_line_desktop.png";

export const GameContainer = styled.main`
	//display: flex;
	//flex-direction: column;
	flex: 1;
	font-family: "Gotham", sans-serif;
	font-size: 16px;
	color: #fff;
	position: relative;
	background: url(${topLine}) no-repeat right top, url(${bottomLine}) no-repeat left bottom,
		linear-gradient(204deg, #0041f9 0%, #0041f9 45%, #ff0019 75%, #ff0019 100%);
	background-size: 25%, 25%, cover;

	@media (max-width: ${media.mobile}) {
		background: url(${topLine}) no-repeat right top, url(${bottomLine}) no-repeat left bottom,
			linear-gradient(270deg, #0041f9 0%, #0041f9 18%, #ff0019 88%, #ff0019 100%);
		background-size: 40%, 40%, cover;
	}
`;

export const DesktopMainContainer = styled(Container)<{team?: TeamRegion}>`
	padding: 40px 5px 20px;

	@media (max-width: ${media.mobile}) {
		padding: 25px 5px;
	}

	.pool-area {
		position: relative;
		height: calc(100% - 72px);
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 2px 4px 0 rgba(28, 28, 30, 0.2),
			0 0.30000001192092896px 0.5px 0 rgba(28, 28, 30, 0.1);
		border: 1px solid ${({team}) => (team === TeamRegion.Europe ? "#0041F9" : "#C81414")};
		background: var(--thirdColor);

		&:after {
			display: block;
			content: "";
			width: 100%;
			height: 80px;
			border-radius: 0 0 8px 8px;
			background: linear-gradient(180deg, rgba(9, 27, 57, 0) 0%, #091b38 100%);
			position: absolute;
			bottom: 0px;
			left: 0;
		}
	}

	form {
		width: 100%;
		margin: 0 auto;
		color: var(--thirdColor);

		&.personal_data {
			.row {
				flex: 1 1 48%;
				max-width: 48%;

				@media (max-width: ${media.mobile}) {
					flex: 1 1 100%;
					max-width: 100%;
				}
			}
		}

		h2 {
			font-family: "GothamCond", sans-serif;
			font-style: normal;
			font-weight: 700;
			font-size: 32px;
			line-height: 104%;
			text-align: center;
			letter-spacing: -0.02em;
			text-transform: uppercase;
		}

		h6 {
			font-family: "Gotham", sans-serif;
			font-style: normal;
			font-weight: 350;
			font-size: 16px;
			line-height: 130%;
			text-align: center;
		}

		.MuiInputBase-input {
			color: var(--thirdColor) !important;

			&:-webkit-autofill {
				color: var(--thirdColor) !important;
				-webkit-text-fill-color: var(--thirdColor);
			}
		}

		.MuiTextField-root,
		.MuiSelect-select {
			//background: rgba(255, 255, 255, 0.09);
			background: rgba(0, 0, 0, 0.1);
			border-radius: 4px 4px 0 0;
			color: var(--thirdColor);
		}

		.MuiSelect-select {
			color: var(--thirdColor);
		}

		.MuiInputBase-formControl {
			color: var(--thirdColor);

			&:after {
				//border-color: #c81414;
				border-color: var(--primaryColor);
			}

			svg {
				fill: var(--thirdColor);

				path {
					fill: var(--thirdColor);
				}
			}
		}

		.MuiInputLabel-formControl {
			color: #a3a3a3;
		}

		.MuiSwitch-track {
			background-color: #616d82;
		}

		.Mui-checked + .MuiSwitch-track {
			background-color: #4b2eb8;
		}

		.Mui-checked {
			.MuiSwitch-thumb {
				background-color: var(--primaryColor);
			}
		}
	}
`;

export const MobileMainContainer = styled(Container)`
	padding: 15px 5px 0;

	&.final_screen {
		max-width: 792px;
		padding: 15px 10px 0;
	}

	.MuiTabs-flexContainer {
		border-bottom: 3px solid var(--thirdColor);

		button {
			font-family: var(--fontFamilySecond);
			font-style: normal;
			font-weight: 500;
			font-size: 11px;
			line-height: 100%;
			text-align: center;
			letter-spacing: 0.2em;
			text-transform: uppercase;
			color: #fff;
			background: var(--thirdColor);
			transition: all ease 0.4s;
			display: flex;
			justify-content: center;
			align-items: center;
			flex: 1;
			max-width: unset;
			border-radius: 6px 6px 0 0;

			&.Mui-selected {
				color: var(--secondaryColor);
				background: #fff;
				border-radius: 6px 6px 0 0;

				&.europe {
					background: var(--primaryColor);
					color: #fff;
					border-top: 3px solid #011536;
					border-left: 3px solid #011536;
					border-right: 3px solid #011536;
				}

				&.usa {
					background: #fff;
					color: var(--secondaryColor);
				}
			}
		}
	}

	.MuiTabs-indicator {
		height: 3px;
		background-color: var(--thirdColor);
	}

	.MuiTabPanel-root {
		padding: 15px 10px;
		border-radius: 0 0 8px 8px;
	}

	.europe {
		background: linear-gradient(45deg, #0076eb 0%, #003c82 100%);
	}

	.usa {
		background: linear-gradient(45deg, #fb4d56 0%, #ff0019 100%);
	}

	form {
		width: 100%;
		//max-width: 320px;
		margin: 0 auto;
		color: var(--thirdColor);

		&.personal_data {
			.row {
				flex: 1 1 48%;
				max-width: 48%;

				@media (max-width: ${media.mobile}) {
					flex: 1 1 100%;
					max-width: 100%;
				}
			}
		}

		h2 {
			font-family: "GothamCond", sans-serif;
			font-style: normal;
			font-weight: 700;
			font-size: 32px;
			line-height: 104%;
			text-align: center;
			letter-spacing: -0.02em;
			text-transform: uppercase;
		}

		h6 {
			font-family: "Gotham", sans-serif;
			font-style: normal;
			font-weight: 350;
			font-size: 16px;
			line-height: 130%;
			text-align: center;
		}

		.MuiInputBase-input {
			color: var(--thirdColor) !important;

			&:-webkit-autofill {
				color: var(--thirdColor) !important;
				-webkit-text-fill-color: var(--thirdColor);
			}
		}

		.MuiTextField-root,
		.MuiSelect-select {
			//background: rgba(255, 255, 255, 0.09);
			background: rgba(0, 0, 0, 0.1);
			border-radius: 4px 4px 0 0;
			color: var(--thirdColor);
		}

		.MuiSelect-select {
			color: var(--thirdColor);
		}

		.MuiInputBase-formControl {
			color: var(--thirdColor);

			&:after {
				//border-color: #c81414;
				border-color: var(--primaryColor);
			}

			svg {
				fill: var(--thirdColor);

				path {
					fill: var(--thirdColor);
				}
			}
		}

		.MuiInputLabel-formControl {
			color: #a3a3a3;
		}

		.MuiSwitch-track {
			background-color: #616d82;
		}

		.Mui-checked + .MuiSwitch-track {
			background-color: #4b2eb8;
		}

		.Mui-checked {
			.MuiSwitch-thumb {
				background-color: var(--primaryColor);
			}
		}
	}
`;
export const ScrollArea = styled(Box)`
	max-height: 712px;
	overflow: auto;
`;

export const TextBlock = styled(Box)`
	width: 100%;
	//padding: 0 40% 30px 0;
	padding: 0 0 20px 0;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
	//background: url(${golfers}) no-repeat 100% 0;

	@media (max-width: ${media.mobile}) {
		padding: 10px 12px 20px;
		background: none;
	}

	&.final_text {
		padding: 60px 40% 30px 0;

		@media (max-width: ${media.mobile}) {
			padding: 0 60px 20px 0;
			background: none;
		}
	}

	h2 {
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 500;
		font-size: 32px;
		text-align: left;
		line-height: 100%;
		letter-spacing: 0.2px;
		text-transform: uppercase;
		color: #ffffff;
		margin-bottom: 20px;

		@media (max-width: ${media.mobile}) {
			font-size: 16px;
			font-style: normal;
			//letter-spacing: 3.2px;
		}
	}

	p {
		font-family: var(--fontFamilySecond);
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 130%;
		text-align: left;
		color: #ffffff;

		@media (max-width: ${media.mobile}) {
			font-size: 14px;
		}
	}
`;

export const SlotContainer = styled(Box)`
	@media (max-width: ${media.mobile}) {
		padding: 0 12px 0;
	}
`;

export const PlayersContainer = styled(Container)`
	//display: flex;
	//justify-content: center;
	//flex-wrap: wrap;
	gap: 30px;
	padding: 20px 5px 30px;
	display: grid;
	grid-template-columns: repeat(3, 160px);
	justify-content: center;

	@media (max-width: ${media.mobile}) {
		gap: 0;
		grid-template-columns: none;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;

		.saved_player_slot {
			width: 30%;
			margin: 1%;
		}

		padding: 10px 5px 30px;
	}
`;
